import { CRM_USER_INFO } from '../util/keys';
// import { userInfo } from 'os';
export function doPreviewOutcall(tel) {
    var params = {
        tel: tel,
        userField:{
            clueId:1758
        } 
    };
    CTILink.Agent.previewOutcall(params);
}

//小休
export function doPause(callback) {
    let params = {
        pauseType: 1,
        pauseDescription: "小休"
    };
    CTILink.Agent.pause(params, callback);
}

//置闲
export function doUnPause() {
    CTILink.Agent.unpause({});
}

//监听
export function spy(agentNo){
    if(agentNo){
        var parms={
            spiedCno:agentNo
        };
        CTILink.Monitor.spy(parms);
    }
}

//监听挂断
export function unspy(agentNo,callback){
    if(agentNo){
        var parms={
            spiedCno:agentNo
        };
        CTILink.Monitor.unspy(parms, callback);
    }
}

//天润签入
export function signTianRunYunCC(operate, self) {
    switch (operate) {
        case 1: //签入
            let currUserInfo = localStorage.getItem(CRM_USER_INFO);
            currUserInfo && (currUserInfo = JSON.parse(currUserInfo));
            doLogin(self);
            break;
        case 2: //签出
            var params = {
                logoutMode: 1
            };
            CTILink.Agent.logout(params, function(token) {
                if (token.code == "0") {}
            });
            break;
        case 3: //置忙
            doPause();
            break;
        case 4: //置闲
            doUnPause();
            break;
    }
}
/**
 * 天润登录
 * agentNo 坐席工号
 * bindPhone 绑定电话
 * bingType 1、座机 2、分机号 3、软电话
 */
export function doLogin(self, callback) {
    //调用座席登录权限验证接口获取sessionKey, qids和webSocketUrl等参数  
    let currUserInfo = localStorage.getItem(CRM_USER_INFO);
    currUserInfo && (currUserInfo = JSON.parse(currUserInfo));
    let url = '//api-1.cticloud.cn/interface/v10/agentLogin/authenticateJsonp';
    let callcentId = currUserInfo.TrDepartId;
    let timestamp = Math.round(((new Date()).getTime() / 1000));
    let authToken = currUserInfo.TrDepartToken;
    if(!authToken||!callcentId){
        callcentId=7100018;
        authToken='6d0563e871a451c63964db91838afea5';
    }
    let sign = calcMD5(callcentId+"" + timestamp + authToken);
    let bindType=currUserInfo.TrBindType;
    let agentNo=currUserInfo.TrAgentNo;
    let bindPhone=currUserInfo.TrBindTel;
    let cno = agentNo;
    url += `?validateType=2&enterpriseId=${callcentId}&cno=${cno}&timestamp=${timestamp}&sign=${sign}`;
    $.ajax({
        type: 'GET',
        dataType: 'jsonp',
        jsonp: 'callback',
        url: url,
        success: function(r) {
            var data = eval("(" + r + ")");
            if (!bindType) {
                bindType = 1;
            }
            var params = {
                sessionKey: data.sessionKey,
                enterpriseId: data.enterpriseId,
                cno: data.cno,
                bindTel: bindPhone,
                bindType: bindType,
                loginStatus: 1,
                webSocketUrl: data.agentGateWayUrl,
                qids: data.qids //班长席时返回
            };
            window.doLoginFn = callback || false
            window.that = self

            CTILink.Agent.login(params, result => {
                if (!!doLoginFn) {
                    doLoginFn(result)
                }
                if (result.code == 0) {
                    //座席登录成功
                    console.warn('login success', result);
                } else {
                    //座席登录失败，失败原因： + result.msg
                    that.$message({
                        type: 'warning',
                        message: result.msg
                    })
                }
            });
        },
        error: function(r) {
            //登录失败，接口请求错误
            console.warn(r);
        }
    });
}